import type { FaireProductEntity } from "../../entity_types/product";

export const p_he74a34gbk: FaireProductEntity = {
  token: "p_he74a34gbk",
  type: "product",
  name: "Ionic Liquid Electrolytes",
  brandToken: "b_n34zp8ykn9",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d984814d81deb2c85be295b5c2b097c6e8a83e08970119b8a6f63ee04edf5883.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a5c2984b6d7d7f1a60d3006cd92570241c8f8c2efa520f33267604d2aa568de3.jpeg",
    "https://cdn.faire.com/fastly/de285581e105a79cb38386add52c4cac52296779b84cf24deef539cd868a6af9.jpeg",
  ],
  priceDollars: 13.85,
  description:
    'Electrolytes truly are the “Spark of Life” as described in the book, "Electrolytes, the Spark of Life, by Gillian Martlew. While many of the known elements can be classified as Electrolytes, there are five elements recognized around the world as essential for maintaining a properly functioning electrical circuit within our body.\n\nThey are:\n- Magnesium\n- Potassium\n- Sodium\n- Chloride\n- Calcium\n\nThese elements are necessary for:\nNerve conduction\nMaintenance of cellular osmotic balance\nPreservation of proper acid-base (pH) balance throughout the body\nThe electrical system within our body encompasses our heart, brain, and nervous system. As such, it is absolutely essential that our cells be replete with these elements. Electrolytes carry electrical impulses from the brain to every part of the body to keep it in a healthy balance.  Easy on the stomach. Safe for all ages. No color or scent.',
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:48.693Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
